import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import WavoipPhoneWidget from "../../components/WavoipCall";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const whatsAppData = useWhatsApps();
  const { user, isAuth, loading: authLoading } = useContext(AuthContext);
  const userId = user?.id;
  const companyId = user?.companyId;
  const identity = isAuth && !authLoading && userId && companyId
    ? String(companyId) + ":" + String(userId)
    : null;
  const [phone, setPhone] = useState({ identity: null, token: null });

  useEffect(() => {
    let active = true;
    setPhone({ identity, token: null });
    if (!identity) return () => { active = false; };
    (async () => {
      try {
        const { data } = await api.get("/call/historical/user/whatsapp");
        if (active) setPhone({ identity, token: data?.whatsapp?.wavoip || null });
      } catch (error) {
        if (active) setPhone({ identity, token: null });
      }
    })();
    return () => { active = false; };
  }, [identity]);

  const token = identity && phone.identity === identity ? phone.token : null;
  return (
    <WhatsAppsContext.Provider value={whatsAppData}>
      {children}
      {token && (
        <WavoipPhoneWidget
          key={identity}
          token={token}
          position="bottom-right"
          name={user?.company?.name || "waVoip"}
          country="BR"
          autoConnect={true}
        />
      )}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };
